import styled from 'styled-components';
import { ReactComponent as AiIcon } from '@elementary/common-ui/assets/ai-generate-magenta.svg';
import { Flex, SvgIcon } from '@elementary/common-ui/components';
import { ButtonBase, Typography } from '@mui/material';
import {
  fontSize,
  fontWeight,
  componentToken,
  space,
} from '@elementary/common-ui/style/utils';
import { FEEDBACK_OPTION_COPY } from '../constants';
import { FeedbackOption } from '../types';

// Fits a title and a one-line subtitle, so cards without a subtitle keep the same height.
const OPTION_CARD_MIN_HEIGHT = '72px';

const OptionButton = styled(ButtonBase)`
  &.MuiButtonBase-root {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-height: ${OPTION_CARD_MIN_HEIGHT};
    gap: ${space('xs')};
    width: 100%;
    padding: ${space('md', 'lg')};
    border: 1px solid ${({ theme }) => theme.palette.border.divider};
    border-radius: ${componentToken('card.radius')};
    text-align: left;
  }
  &:hover {
    background: ${({ theme }) => theme.palette.surface.selected};
  }
`;

type Props = {
  option: FeedbackOption;
  onClick: (option: FeedbackOption) => void;
};

const FeedbackOptionCard = ({ option, onClick }: Props) => {
  const { title, subtitle, isAiPowered } = FEEDBACK_OPTION_COPY[option];

  return (
    <OptionButton onClick={() => onClick(option)}>
      <Flex sx={{ alignItems: 'center', gap: 1 }}>
        {isAiPowered && (
          <SvgIcon width={16}>
            <AiIcon />
          </SvgIcon>
        )}
        <Typography sx={{ fontWeight: fontWeight('bold') }}>{title}</Typography>
      </Flex>
      {subtitle && (
        <Typography
          sx={{ color: 'content.tertiary', fontSize: fontSize('sm') }}
        >
          {subtitle}
        </Typography>
      )}
    </OptionButton>
  );
};

export default FeedbackOptionCard;
